import script from "./ExhibitForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ExhibitForm.vue?vue&type=script&setup=true&lang=js"

import "./ExhibitForm.vue?vue&type=style&index=0&id=1ea6df62&lang=css"

const __exports__ = script;

export default __exports__